type AppBadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

const getNavigator = (): AppBadgeNavigator | null => {
  if (typeof navigator === "undefined") return null;
  return navigator as AppBadgeNavigator;
};

export const setBadgeCount = async (count: number): Promise<void> => {
  const nav = getNavigator();
  if (!nav) return;
  const safeCount = Math.max(0, count);
  try {
    if (safeCount === 0 && nav.clearAppBadge) {
      await nav.clearAppBadge();
      return;
    }
    if (nav.setAppBadge) {
      await nav.setAppBadge(safeCount);
    }
  } catch (error) {
    console.error("Failed to set badge count:", error);
  }
};

export const clearBadge = () => setBadgeCount(0);
